import { createAction, props } from '@ngrx/store';
import { School } from '@shared/types/school.model';

export const loadSchools = createAction(
  '[School] Load Schools',
  props<{ tenantCode: string }>()
);

export const loadSchoolsSuccess = createAction(
  '[School] Load Schools Success',
  props<{ schools: School[] }>()
);

export const loadSchoolsFailure = createAction(
  '[School] Load Schools Failure',
  props<{ error: string }>()
);

export const selectSchool = createAction(
  '[School] Select School',
  props<{ schoolId: string | null }>()
);

export const clearSchoolState = createAction('[School] Clear School State');
